import { render } from "./AuthenticatedLayout.vue?vue&type=template&id=bbae908e&scoped=true&ts=true"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=ts"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=ts"

import "./AuthenticatedLayout.vue?vue&type=style&index=0&id=bbae908e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbae908e"]])

export default __exports__